function NRNuGetIconDark({ height = '24', width = '24' }) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.7243 20.1208C14.8859 20.1208 13.3953 18.6301 13.3953 16.7915C13.3953 14.9537 14.8859 13.4622 16.7243 13.4622C18.5627 13.4622 20.0533 14.9537 20.0533 16.7915C20.0533 18.6301 18.5627 20.1208 16.7243 20.1208ZM10.0838 12.4901C8.93449 12.4901 8.00321 11.5578 8.00321 10.4092C8.00321 9.25979 8.93449 8.32842 10.0838 8.32842C11.2332 8.32842 12.1644 9.25979 12.1644 10.4092C12.1644 11.5578 11.2332 12.4901 10.0838 12.4901ZM16.8716 5.99457H11.3155C8.48425 5.99457 6.18726 8.29179 6.18726 11.1242V16.68C6.18726 19.5132 8.48425 21.8088 11.3155 21.8088H16.8716C19.7046 21.8088 21.9999 19.5132 21.9999 16.68V11.1242C21.9999 8.29179 19.7046 5.99457 16.8716 5.99457Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.32898 4.04277C5.32898 4.96249 4.58329 5.70743 3.66449 5.70743C2.74486 5.70743 2 4.96249 2 4.04277C2 3.12388 2.74486 2.37811 3.66449 2.37811C4.58329 2.37811 5.32898 3.12388 5.32898 4.04277Z"
        fill="white"
      />
    </svg>
  );
}
export default NRNuGetIconDark;
